/**
 * @link https://mui.com/material-ui/react-link/
 */

import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import ShowCode from "../../helpers/ShowCode.js";

const preventDefault = (event) => event.preventDefault();

export default function FactureeLink() {
  return (
    <>
      <Box
        sx={{
          typography: 'body1',
          '& > :not(style) + :not(style)': {
            ml: 2,
          },
        }}
        onClick={preventDefault}
      >
        <Link href="#">Link</Link>
        <Link href="#" variant="body2">
          {'Link strong'}
        </Link>
      </Box>
      
      <ShowCode 
        codeString={`function LinkExample() {
  // Prevent default behavior for links
  const preventDefault = (event) => event.preventDefault();

  return (
    <Box
      sx={{
        typography: 'body1',
        '& > :not(style) + :not(style)': {
          ml: 2,
        },
      }}
      onClick={preventDefault}
    >
      {/* Basic link */}
      <Link href="#">Link</Link>
      
      {/* Link with variant */}
      <Link href="#" variant="body2">
        Link strong
      </Link>
    </Box>
  );
}`} 
        scope={{ 
          React, 
          Box, 
          Link 
        }} 
      />
    </>
  );
}